import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Video, FileText } from 'lucide-react';

export default function InstructorDashboard() {
  const { lang } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--bg-app)] py-12" data-testid="instructor-dashboard-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Hero Başlık */}
        <div className="text-center mb-12">
          <p className="text-xs font-bold tracking-widest uppercase text-[var(--brand-primary)] mb-2">
            {lang === 'tr' ? 'EĞİTMEN PANELİ' : 'INSTRUCTOR PANEL'}
          </p>
          <h1 className="font-display text-4xl font-bold text-[var(--text-primary)]">
            {lang === 'tr' ? 'Eğitmen Paneli' : 'Instructor Panel'}
          </h1>
        </div>

        {/* İki Ana Kart */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

          {/* Mülakat Değerlendirmeleri */}
          <button
            onClick={() => navigate('/instructor/interview-reviews')}
            className="card-clay p-8 flex flex-col items-center gap-4 text-center cursor-pointer
              border-2 border-cyan-300 hover:border-cyan-500
              transition-all duration-200 hover:shadow-[0_6px_0_0_#06b6d4] active:shadow-none active:translate-y-1
              focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 rounded-2xl"
            data-testid="interview-reviews-btn"
            aria-label={lang === 'tr' ? 'Mülakat Değerlendirmeleri' : 'Interview Reviews'}
          >
            <div className="w-16 h-16 rounded-2xl bg-cyan-50 border-2 border-cyan-200 flex items-center justify-center">
              <Video size={32} strokeWidth={2} className="text-cyan-600" aria-hidden="true" />
            </div>
            <div>
              <p className="font-display text-lg font-bold text-cyan-700">
                {lang === 'tr' ? 'Mülakat Değerlendirmeleri' : 'Interview Reviews'}
              </p>
              <p className="text-sm text-[var(--text-muted)] mt-1">
                {lang === 'tr' ? 'Öğrenci mülakatlarını incele ve değerlendir' : 'Review and evaluate student interviews'}
              </p>
            </div>
          </button>

          {/* CV Değerlendirmeleri */}
          <button
            onClick={() => navigate('/instructor/cv-reviews')}
            className="card-clay p-8 flex flex-col items-center gap-4 text-center cursor-pointer
              border-2 border-indigo-300 hover:border-indigo-500
              transition-all duration-200 hover:shadow-[0_6px_0_0_#6366f1] active:shadow-none active:translate-y-1
              focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 rounded-2xl"
            data-testid="cv-reviews-btn"
            aria-label={lang === 'tr' ? 'CV Değerlendirmeleri' : 'CV Reviews'}
          >
            <div className="w-16 h-16 rounded-2xl bg-indigo-50 border-2 border-indigo-200 flex items-center justify-center">
              <FileText size={32} strokeWidth={2} className="text-indigo-600" aria-hidden="true" />
            </div>
            <div>
              <p className="font-display text-lg font-bold text-indigo-700">
                {lang === 'tr' ? 'CV Değerlendirmeleri' : 'CV Reviews'}
              </p>
              <p className="text-sm text-[var(--text-muted)] mt-1">
                {lang === 'tr' ? 'Öğrenci CV başvurularını incele' : 'Review student CV submissions'}
              </p>
            </div>
          </button>

        </div>
      </div>
    </div>
  );
}
